/**
 * Mock bundle design for the "Single Solid Shelf" inseparable soft bundle (ISB) choice
 * (catalog choice 280102, see packoutMockData.js). Same shape/geometry as
 * wallStorage-isb-singleWireShelf.mock.js (see that file for the full ISB design-shape
 * explanation) — the solid shelf shares the exact same physical spec (width/height) as
 * the wire shelf, per catalog confirmation, so only the shelf's own Sku/ChoiceId/Name
 * differ here.
 */

const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000012';
const BRACKET_CHOICE_ID = 284358; // shared "Shelf Bracket" part choice, hidden from selector
const SHELF_CHOICE_ID = 284359;
const CELL_WIDTH = 330; // centiunits (3.3in), the bracket's own physical width
const SHELF_WIDTH = 2100; // centiunits (21in), the shelf's own physical width

const CELL_HEIGHT = 380; // centiunits (3.8in)

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Single Solid Shelf (mock ISB)',
  Version: 1,
  ProductTypeId: null,
  Sku: null,
  Surface: null,
  Matrix: null,
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'isb-single-solid-shelf-bracket-left',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: 0, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-single-solid-shelf-shelf',
      Type: 'Accessory',
      Sku: 324536656,
      Name: 'Single Solid Shelf (mock)',
      ChoiceId: SHELF_CHOICE_ID,
      // The shelf overlaps HALF of bracket-left's width (it sits on top of/behind the
      // bracket, not butted flush against its edge).
      Origin: {
        Row: 0, Column: CELL_WIDTH / 2, Height: CELL_HEIGHT / 2, Width: SHELF_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-single-solid-shelf-bracket-right',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      // Bracket-right's own anchor sits exactly one shelf-width from bracket-left's —
      // it overlaps the shelf's right end by half its own width, mirroring
      // bracket-left's overlap on the left end, so the two halves cancel out and the
      // bracket-to-bracket anchor distance is just SHELF_WIDTH (confirmed against real
      // bracket/shelf measurements; NOT bracket-width + shelf-width).
      Origin: {
        Row: 0, Column: SHELF_WIDTH, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const wallStorageIsbSingleSolidShelfMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default wallStorageIsbSingleSolidShelfMock;
